import React from 'react';
import { IndefiniteLoader, LoaderText, LoaderWrapper } from './styledComponents';

export default () => (
  <LoaderWrapper>
    <LoaderText>Loading</LoaderText>
    <IndefiniteLoader />
  </LoaderWrapper>
);
